import { render } from "./TopicTestView.vue?vue&type=template&id=7dde770d&scoped=true"
import script from "./TopicTestView.vue?vue&type=script&lang=js"
export * from "./TopicTestView.vue?vue&type=script&lang=js"

import "./TopicTestView.vue?vue&type=style&index=0&id=7dde770d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dde770d"]])

export default __exports__